export default __webpack_public_path__ + "static/media/fsaLogo.184df129.png";